module.exports = __webpack_public_path__ + "static/media/delete-blue.cbb7caf0.svg";